import React, { useEffect, useState } from 'react';
import { convertTimestampToDateTime, convertTimestampToDateTimeString } from '../../helper/helper';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface InlineEditDataProps {
  date: Date | null | undefined;
  submit?: (id: string, value: string) => void;
  id: string | null | undefined;
}

const InlineEditData: React.FC<InlineEditDataProps> = ({ id, date, submit }) => {
  const [isExpireDataEditing, setSsExpireDataEditing] = useState(false);
  const [tempDateValue, setTempDateValue] = useState<string | null>(null);

  useEffect(() => {
    if (date) {
      setTempDateValue(convertTimestampToDateTimeString(date));
    }
  }, [date]);

  const handleCellClick = () => {
    setSsExpireDataEditing(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTempDateValue(convertTimestampToDateTimeString(e.target.value));
  };

  const handleBlur = () => {
    setSsExpireDataEditing(false);
    const newTimestamp = convertTimestampToDateTimeString(tempDateValue);
    submit && id && submit(id, newTimestamp);
  };

  return (
    <div className="flex w-full h-full">
      {isExpireDataEditing ? (
          <input
            type="datetime-local"
            value={tempDateValue!}
            onChange={handleChange}
            onBlur={handleBlur}
            autoFocus
            className="border p-1"
          />
        ) :
        <span className="flex w-full h-full cursor-pointer">{convertTimestampToDateTime(date)}
          {date && <FontAwesomeIcon
            icon={faEdit}
            className="cursor-pointer"
            title="Edit Expire"
            onClick={handleCellClick}
          />}
        </span>}
    </div>
  );
};

export default InlineEditData;
